import { DATA_SCROLL_ITEM } from '../../constants/ScrollDataAttributeNames';

export const getScrollItemNode = dataScrollableAttribute =>
  document.querySelector(`[${DATA_SCROLL_ITEM}='${dataScrollableAttribute}']`);

export const getScrollItemAttributeProp = value => ({
  [DATA_SCROLL_ITEM]: value,
});
